module.exports = __webpack_public_path__ + "static/img/defaultHeadTwo.38cee14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/defaultHeadTwo.png
// module id = f5fD
// module chunks = 1